import { RepeatWrapping, type Texture } from "three";

// Allow the cache to hold weak references to textures
// which are otherwise managed by the useTexture hook
const srgbTextureCache = new WeakMap<Texture, Texture>();

export const getTextureAsSrgb = (texture: Texture) => {
  const cachedSrgbTexture = srgbTextureCache.get(texture);
  if (cachedSrgbTexture) {
    return cachedSrgbTexture;
  }

  const srgbTexture = texture.clone();
  srgbTexture.colorSpace = "srgb";
  // Re-apply the useTextures texture settings to the cloned texture
  // At least with particle textures like Mythic or Enlightenment,
  // they didn't seem to carry over from the cloning
  srgbTexture.flipY = false;
  srgbTexture.wrapS = srgbTexture.wrapT = RepeatWrapping;
  srgbTexture.needsUpdate = true;

  srgbTextureCache.set(texture, srgbTexture);

  return srgbTexture;
};
